import { Link, useLocation } from "react-router";
import { cn } from "@/components/ui";
import { openExceptions } from "@/lib/finance";
import { useCase } from "./case-context";

/** Overview is the case root, so its segment is empty. */
const TABS = [
  { segment: "", label: "Overview" },
  { segment: "evidence", label: "Evidence" },
  { segment: "analysis", label: "Analysis" },
  { segment: "decision", label: "Decision" },
  { segment: "activity", label: "Activity" },
] as const;

export function CaseTabs() {
  const pathname = useLocation().pathname;
  const { case: kase, evidence } = useCase();
  const base = `/cases/${kase.id}`;
  const exceptions = openExceptions(evidence).length;

  return (
    <nav aria-label="Case sections" className="border-b border-line bg-surface px-6">
      <ul className="-mb-px flex gap-1">
        {TABS.map((tab) => {
          const href = tab.segment ? `${base}/${tab.segment}` : base;
          const active = pathname === href;
          return (
            <li key={tab.label}>
              <Link
                to={href}
                aria-current={active ? "page" : undefined}
                className={cn(
                  "inline-flex items-center gap-1.5 border-b-2 px-3 py-2.5 text-sm transition-colors",
                  active
                    ? "border-accent font-medium text-accent"
                    : "border-transparent text-ink-muted hover:border-line-strong hover:text-ink",
                )}
              >
                {tab.label}
                {tab.segment === "evidence" && exceptions > 0 ? (
                  <span className="numeric rounded-full bg-caution-soft px-1.5 text-[0.6875rem] font-medium text-caution">
                    {exceptions}
                  </span>
                ) : null}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
